<template>
  <div id="data-view">
    <dv-full-screen-container>

      <top-header />

      <div class="main-content">
        <digital-flop />

        <div class="block-left-right-content">
          <left />
          <center />
          <right :school-id="50" :name="'海委校外班'" />
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from './topHeader'
import digitalFlop from './digitalFlop'
import left from './left'
import right from './right'
import center from './center'

export default {
  name: 'DataView',
  components: {
    topHeader,
    digitalFlop,
    left,
    right,
    center
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    height: calc(100% - 100px);
    // flex: 1;
    display: flex;
    flex-direction: column;
  }

  .block-left-right-content {
    height: calc(100% - 15% - 20px);
    // flex: 1;
    display: flex;
    padding-top: 20px;
  }

  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }

  .block-top-content {
    height: 55%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
}
</style>
